var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"onboarding"}},[_c('div',{staticClass:"testimg"},[_c('img',{attrs:{"id":"aq1","src":"/images/aq1.png"}})])])
}]

export { render, staticRenderFns }